import { IExecutionOptions, IQueryOptions } from '@kurtosys/types/query/index.js';

import { getQueryClass } from '../queryUtils/getQueryClass.js';

import { BaseTransform } from './BaseTransform.js';

export class ReplaceTransform extends BaseTransform {
	execute(queryResponse: any, queryOptions: IQueryOptions, executionOptions: IExecutionOptions): any {
		let response: any = queryResponse;
		if (this.options.replaceTransformOptions) {
			const { replaceTransformOptions } = this.options;
			const { searchValue, replaceValue, replaceQuery, isRegex = false, regexFlags } = replaceTransformOptions;
			let value: any = replaceValue;

			if (replaceQuery) {
				const query = getQueryClass(
					this.dependencies,
					replaceQuery,
					this.translationHelper,
					(this.callStackLevel || 1) + 1,
				);
				value = query.execute(executionOptions);
			}

			if (
				typeof response === 'string' &&
				typeof searchValue === 'string' &&
				(typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')
			) {
				if (isRegex) {
					response = response.replace(new RegExp(searchValue, regexFlags), value.toString());
				} else {
					response = response.split(searchValue).join(value.toString());
				}
			}
		}
		return response;
	}
}
